import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Arrow.scss';
export var ArrowColor;
(function (ArrowColor) {
    ArrowColor["red"] = "red";
    ArrowColor["amber"] = "amber";
    ArrowColor["green"] = "green";
})(ArrowColor || (ArrowColor = {}));
;
export var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection["up"] = "up";
    ArrowDirection["down"] = "down";
    ArrowDirection["diagonal"] = "diagonal";
})(ArrowDirection || (ArrowDirection = {}));
;
export const Arrow = ({ color, direction }) => {
    return (_jsxs("svg", { className: "arrow", xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 32 32", children: [_jsx("g", { children: _jsx("circle", { className: color, cx: "16", cy: "16", r: "16" }) }), _jsxs("g", { className: `arrow-paths ${direction}`, children: [_jsx("path", { d: "M15.5,8.2c.6,0,1,.5,1,1v13.5c0,.6-.5,1-1,1s-1-.5-1-1v-13.5c0-.6.5-1,1-1Z" }), _jsx("path", { d: "M15.5,8.2h0c.3,0,.5.1.7.3l6.3,6.3c.4.4.4,1.1,0,1.5s-1.1.4-1.5,0l-5.6-5.6-5.6,5.6c-.4.4-1.1.4-1.5,0s-.4-1.1,0-1.5l6.3-6.3c.2-.2.5-.3.7-.3Z" })] })] }));
};
